
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-test-chatgpt-api-key-quickly",
      function () {
        return require("private-next-pages/how-to-test-chatgpt-api-key-quickly.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-test-chatgpt-api-key-quickly"])
      });
    }
  